export const setInTransition = (innerRefScrollHeight) =>
  innerRefScrollHeight !== 0;
